import React, { useState, useEffect } from "react";
import styles from "./styles";
// import { useGeolocation } from "react-use";
import { firestore, auth } from "../../firebase";
import { Refresh as RefreshIcon, Home as HomeIcon } from "@material-ui/icons";
import { Fab, Box, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";

import { useParams, Link } from "react-router-dom";
import Loader from "../Loader";
import EmptyState from "../EmptyState";
import Formu from "./Formu";
import listados from "../../services/listados";
import { ButtonBack } from "../ButtonBack";

function Report(props) {
  const { classes } = props;
  const [loading, setLoading] = useState(true);
  const [assignments, setAssignments] = useState(null);
  const [error, setError] = useState(null);
  const [errorAccess, setErrorAccess] = useState(null);
  const { reportId } = useParams();
  // const geolocation = useGeolocation();
  const dateToday = moment(new Date()).format("DD/MM/YYYY");

  useEffect(() => {
    return firestore
      .collection("assignments")
      .doc(reportId)
      .onSnapshot(
        (doc) => {
          if (doc.exists) {
            auth.onAuthStateChanged((user) => {
              if (user) {
                let data = doc.data();
                data.stringDate = moment(data.dateActivity.toDate()).format(
                  "DD/MM/YYYY"
                );
                data.hour = moment(data.dateActivity.toDate()).format(
                  "HH:mm A"
                );
                if (user.uid === data.userId) {
                  setAssignments(data);
                  setLoading(false);
                } else {
                  setLoading(false);
                  setErrorAccess(true);
                }
              } else {
                // No user is signed in.
              }
            });
          } else {
            setLoading(false);
          }
        },
        (error) => {
          setLoading(false);
          setError(error);
        }
      );
  }, [reportId]);

  if (error) {
    return (
      <EmptyState
        title="No se pudo recuperar la asignación."
        description="Se produjo un error al intentar recuperar a la asignación solicitada."
        button={
          <Fab
            variant="extended"
            color="primary"
            onClick={() => window.location.reload()}
          >
            <Box clone mr={1}>
              <RefreshIcon />
            </Box>
            Recargar
          </Fab>
        }
      />
    );
  }

  if (errorAccess) {
    return (
      <EmptyState
        title="No tienes acceso."
        description="Regresa al inicio para poder acceder a tus asignaciones."
        button={
          <Fab variant="extended" color="primary" component={Link} to="/">
            <Box clone mr={1}>
              <HomeIcon />
            </Box>
            Inicio
          </Fab>
        }
      />
    );
  }

  console.log(loading);

  if (loading) {
    return <Loader />;
  }
  // if (loading || geolocation.loading) {
  //   return <Loader />;
  // }

  // if (geolocation.latitude === null) {
  //   return (
  //     <EmptyState
  //       title="No se pudo recuperar la ubicación."
  //       description="Se produjo un error al intentar recuperar la ubicación solicitada. Por favor activa el GPS del dispositivo."
  //       button={
  //         <Fab
  //           variant="extended"
  //           color="primary"
  //           onClick={() => window.location.reload()}
  //         >
  //           <Box clone mr={1}>
  //             <RefreshIcon />
  //           </Box>
  //           Recargar
  //         </Fab>
  //       }
  //     />
  //   );
  // }

  if (!assignments) {
    return (
      <EmptyState
        title="La asignación no existe."
        description="La asignación solicitada no existe."
        button={
          <Fab variant="extended" color="primary" component={Link} to="/">
            <Box clone mr={1}>
              <HomeIcon />
            </Box>
            Inicio
          </Fab>
        }
      />
    );
  }

  if (dateToday !== assignments.stringDate) {
    return (
      <EmptyState
        title="La actividad ha culminado."
        description="No se puede recuperar la actividad solicitada. La fechas no coinciden."
        button={
          <Fab variant="extended" color="primary" component={Link} to="/">
            <Box clone mr={1}>
              <HomeIcon />
            </Box>
            Inicio
          </Fab>
        }
      />
    );
  }

  return (
    <>
      <div style={{ float: "right", marginTop: "10px" }}>
        <ButtonBack />
      </div>
      <div className={classes.center}>
        <Typography variant="h6" color="textSecondary">
          {assignments.nameActivity} - {listados.profiles[assignments.profile]}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {assignments.address}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {assignments.stringDate} {assignments.hour}
        </Typography>
        <br></br>
        <Formu
          // geolocation={geolocation}
          classes={classes}
          id={assignments.id}
          reports={assignments.reports ? assignments.reports : null}
        />
      </div>
    </>
  );
}

export default withStyles(styles)(Report);
